module.exports = __webpack_public_path__ + "img/wetNwild1.ea0185a7.jpg";